import React from "react";
import TextAreaBox from "../../../../../common/input/TextAreaBox";
import TextAreaWithSpeech from "../../../../../common/input/TextAreaWithSpeech";

const Notes = ({ formik }) => {
  return (
    <div className="shadow-card rounded-15 pb-4">
      <div
        className={`shadow-card rounded-tl-15 rounded-tr-15 bg-secondary p-3 text-bodyBB text-darkgrey mb-4 sticky left-0`}
      >
        Notes
      </div>
      <div className="p-2 min-h-[100px]">
        {/* <TextAreaBox
          value={formik.values.notes}
          placeholder={"Enter Notes"}
          error={formik.touched.notes && formik.errors.notes}
          name={"notes"}
          onChange={formik.handleChange}
        /> */}
          <TextAreaWithSpeech
           value={formik.values.notes}
          placeholder={"Enter Notes"}
          error={formik.touched.notes && formik.errors.notes}
          name={"notes"}
          onChange={formik.handleChange}
            />
      </div>
    </div>
  );
};

export default Notes;
